<div *ngIf="randomMode === 0 || legacyCampaign">
  <div *ngIf="hideStepUber">
    <div
      *ngIf="collapsedSteps && savedSteps"
      class="point-style"
      (click)="collapsedSteps = false"
    >
      . . .
    </div>
    <mat-stepper
      linear
      #stepper
      labelPosition="bottom"
      [orientation]="(stepperOrientation | async)!"
      (selectionChange)="redirectUrlStepControl($event)"
      [appHighlight]="collapsedSteps"
      [savedSteps]="savedSteps"
      [uberAprovePrefilter]="uberAprovePrefilter"
      [canPassStep]="canPassStep"
      [creditType]="creditType"
      [hideStepUber]="hideStepUber"
    >
      <ng-template matStepperIcon="edit">
        <mat-icon>check</mat-icon>
      </ng-template>
      <!-- STEP 1 - BIENVENIDA -->
      <mat-step [stepControl]="completedSteps.controls['step1']">
        <ng-template matStepLabel> BIENVENIDA </ng-template>
        <!-- BIENVENIDA DAE -->
        <app-step-bienvenida
          [saveRequest]="requestValueWelcome.asObservable()"
          (formValidEvent)="enableWelcome = $event"
          (stepWelcomeSavedEvent)="markStepSaved(1, $event)"
          [dataWelcome]="comboData"
          *ngIf="creditType === '9'"
        ></app-step-bienvenida>
        <div class="button-position" *ngIf="creditType === '9'">
          <button
            onclick="dataLayer.push({'event': 'login'});"
            class="boton-siguiente"
            [disabled]="!enableWelcome || clicked"
            (click)="sendRequestWelcome(); clicked = true"
            mat-button
          >
            Siguiente
          </button>
        </div>
        <!-- BIENVENIDA LTO (FLUJO NUEVO LTO)-->
        <app-step-bienvenida-lto
          [saveRequest]="requestValueWelcomeLto.asObservable()"
          (formValidEvent)="enableWelcomeLto = $event"
          (stepWelcomeLtoSavedEvent)="markStepSaved(1, $event)"
          [dataWelcomeLto]="comboData"
          *ngIf="creditType === '1'"
        ></app-step-bienvenida-lto>
        <div class="button-position" *ngIf="creditType === '1'">
          <button
            onclick="dataLayer.push({'event': 'login'});"
            class="boton-siguiente"
            (click)="sendRequestWelcomeLto(); clicked = true"
            mat-button
            [disabled]="!enableWelcomeLto || clicked"
          >
            Siguiente
          </button>
        </div>
      </mat-step>
      <!-- STEP 2 - SOBRE TI DAE| DATOS DE UBER LTO-->
      <mat-step [stepControl]="completedSteps.controls['step2']">
        <ng-template matStepLabel
          >{{ creditType === "9" ? "SOBRE TI" : "DATOS UBER" }}
        </ng-template>
        <!-- SOBRE TI DAE -->
        <app-step-sobre-ti
          *ngIf="creditType === '9' && completedSteps.controls['step1'].valid"
          [saveRequest]="requestValueAboutYou.asObservable()"
          (formValidEvent)="enableAboutYou = $event"
          (stepAboutYouSavedEvent)="markStepSaved(2, $event)"
        ></app-step-sobre-ti>
        <div class="button-position" *ngIf="creditType === '9'">
          <button
            class="boton-siguiente"
            mat-button
            matStepperPrevious
            (click)="clicked = false"
          >
            Regresar
          </button>
          <button
            class="boton-siguiente"
            [disabled]="!enableAboutYou"
            (click)="sendRequestAboutYou()"
            mat-button
          >
            Siguiente
          </button>
        </div>
        <!-- DATOS UBER LTO(flujo nuevo LTO) -->
        <app-step-datos-uber-lto
          *ngIf="creditType === '1' && completedSteps.controls['step1'].valid"
          [saveRequest]="requestValueDataUberLto.asObservable()"
          (formValidEvent)="enableDataUberLto = $event"
          (stepDataUberLtoSavedEvent)="markStepSaved(2, $event)"
        ></app-step-datos-uber-lto>
        <div class="button-position" *ngIf="creditType === '1'">
          <button
            class="boton-siguiente"
            mat-button
            matStepperPrevious
            (click)="clicked = false"
          >
            Regresar
          </button>
          <button
            class="boton-siguiente"
            (click)="sendRequestDataUberLto()"
            [disabled]="!enableDataUberLto"
            mat-button
          >
            Siguiente
          </button>
        </div>
      </mat-step>
      <mat-step [stepControl]="completedSteps.controls['step3']">
        <ng-template matStepLabel
          >{{
            creditType === "9" ? "CARGA DOCUMENTOS" : "DOCUMENTOS PRINCIPALES"
          }}
        </ng-template>
        <!-- DOCUMENTOS PRINCIPALES (flujo nuevo LTO) -->
        <app-step-documentos-principales-lto
          *ngIf="creditType === '1' && completedSteps.controls['step2'].valid"
          [saveRequest]="requestValueMainDocumentsLto.asObservable()"
          (formValidEvent)="enableMainDocumentsLto = $event"
          (stepMainDocumentLtoSavedEvent)="markStepSaved(3, $event)"
          [dataMainDocumentsLto]="comboData"
        ></app-step-documentos-principales-lto>
        <div class="button-position" *ngIf="creditType === '1'">
          <button class="boton-siguiente" mat-button matStepperPrevious>
            Regresar
          </button>
          <button
            class="boton-siguiente"
            (click)="sendRequestMainDocumentsLto()"
            mat-button
          >
            Siguiente
          </button>
        </div>
        <!-- CARGA DOCUMENTO DAE -->
        <app-step-cargar-documentos
          *ngIf="creditType === '9' && completedSteps.controls['step2'].valid"
          [saveRequest]="requestValueLoadDocuments.asObservable()"
          (formValidEvent)="enableLoadDocuments = $event"
          (stepLoadDocumentSavedEvent)="markStepSaved(3, $event)"
          [dataLoadDocuments]="comboData"
        ></app-step-cargar-documentos>
        <div class="button-position" *ngIf="creditType === '9'">
          <button class="boton-siguiente" mat-button matStepperPrevious>
            Regresar
          </button>
          <button
            class="boton-siguiente"
            mat-button
            [disabled]="!enableLoadDocuments"
            (click)="sendRequestLoadDocuments()"
          >
            Siguiente
          </button>
        </div>
      </mat-step>
      <!-- STEP 4 - DATOS SECUNDARIOS LTO| MAS INFORMACION DAE -->
      <mat-step [stepControl]="completedSteps.controls['step4']">
        <ng-template matStepLabel>
          {{
            creditType === "9" ? "MAS INFORMACIÓN " : "DATOS SECUNDARIOS"
          }}</ng-template
        >
        <!-- MAS INFORMACION  -->
        <app-step-mas-informacion
          *ngIf="creditType === '9' && completedSteps.controls['step3'].valid"
          [saveRequest]="requestValueMoreInformation.asObservable()"
          (formValidEvent)="enableMoreInformation = $event"
          (stepMoreInformationSavedEvent)="markStepSaved(4, $event)"
          [dataMoreInformation]="comboData"
        ></app-step-mas-informacion>
        <div class="button-position" *ngIf="creditType === '9'">
          <button
            class="boton-siguiente"
            (click)="completeDocument()"
            mat-button
            matStepperPrevious
          >
            Regresar
          </button>
          <button
            class="boton-siguiente"
            mat-button
            (click)="sendRequestMoreInformation()"
            [disabled]="!enableMoreInformation"
          >
            Finalizar
          </button>
        </div>
        <!-- DOCUMENTOS SECUNDARIOS LTO (flujo nuevo LTO)-->
        <app-step-documentos-secundarios-lto
          *ngIf="creditType === '1' && completedSteps.controls['step3'].valid"
          [saveRequest]="requestValueSecondaryDocumentsLto.asObservable()"
          (formValidEvent)="enableSecondaryDocumentsLto = $event"
          (stepSecondaryDocumentsSavedEvent)="markStepSaved(4, $event)"
          [dataSecondaryDocuments]="comboData"
        ></app-step-documentos-secundarios-lto>
        <div class="button-position" *ngIf="creditType === '1'">
          <button
            class="boton-siguiente"
            (click)="completeDocument()"
            mat-button
            matStepperPrevious
          >
            Regresar
          </button>
          <button
            class="boton-siguiente"
            (click)="sendRequestSecondaryDocumentsLto()"
            mat-button
            [disabled]="!enableSecondaryDocumentsLto"
          >
            Siguiente
          </button>
        </div>
      </mat-step>
      <!-- STEP 5 -  DOCUMENTOS SECUNDARIOS -->
      <mat-step *ngIf="creditType === '1'">
        <ng-template matStepLabel> MAS INFORMACIÓN </ng-template>
        <app-step-mas-informacion-lto
          *ngIf="completedSteps.controls['step4'].valid"
          [saveRequest]="requestValueMoreInformationLto.asObservable()"
          (formValidEvent)="enableMoreInformationLto = $event"
          (stepMoreInformationLtoSavedEvent)="markStepSaved(5, $event)"
          [dataMoreInformationLto]="comboData"
        ></app-step-mas-informacion-lto>
        <div class="button-position">
          <button class="boton-siguiente" mat-button matStepperPrevious>
            Regresar
          </button>
          <button
            class="boton-siguiente"
            mat-button
            [disabled]="!enableMoreInformationLto"
            (click)="sendRequestMoreInformationLto()"
          >
            Finalizar
          </button>
        </div>
      </mat-step>
    </mat-stepper>
  </div>
  <div *ngIf="!hideStepUber">
    <div
      *ngIf="collapsedSteps && savedSteps"
      class="point-style"
      (click)="collapsedSteps = false"
    >
      . . .
    </div>
    <mat-stepper
      linear
      #stepper
      labelPosition="bottom"
      [orientation]="(stepperOrientation | async)!"
      (selectionChange)="redirectUrlStepControl($event)"
      [appHighlight]="collapsedSteps"
      [savedSteps]="savedSteps"
      [uberAprovePrefilter]="uberAprovePrefilter"
      [canPassStep]="canPassStep"
      [creditType]="creditType"
      [hideStepUber]="hideStepUber"
      hidden
    >
      <ng-template matStepperIcon="edit">
        <mat-icon>check</mat-icon>
      </ng-template>
      <!-- STEP 1 - BIENVENIDA -->
      <mat-step [stepControl]="completedSteps.controls['step1']">
        <ng-template matStepLabel> BIENVENIDA </ng-template>
        <!-- BIENVENIDA DAE -->
        <app-step-bienvenida
          [saveRequest]="requestValueWelcome.asObservable()"
          (formValidEvent)="enableWelcome = $event"
          (stepWelcomeSavedEvent)="markStepSaved(1, $event)"
          [dataWelcome]="comboData"
          *ngIf="creditType === '9'"
        ></app-step-bienvenida>
        <div class="button-position" *ngIf="creditType === '9'">
          <button
            onclick="dataLayer.push({'event': 'login'});"
            class="boton-siguiente"
            [disabled]="!enableWelcome || clicked"
            (click)="sendRequestWelcome(); clicked = true"
            mat-button
          >
            Siguiente
          </button>
        </div>
        <!-- BIENVENIDA LTO (LTO)-->
        <app-step-bienvenida-lto
          [saveRequest]="requestValueWelcomeLto.asObservable()"
          (formValidEvent)="enableWelcomeLto = $event"
          (stepWelcomeLtoSavedEvent)="markStepSaved(1, $event)"
          [dataWelcomeLto]="comboData"
          *ngIf="creditType === '1'"
        ></app-step-bienvenida-lto>
        <div class="button-position" *ngIf="creditType === '1'">
          <button
            onclick="dataLayer.push({'event': 'login'});"
            class="boton-siguiente"
            (click)="sendRequestWelcomeLto(); clicked = true"
            mat-button
            [disabled]="!enableWelcomeLto || clicked"
          >
            Siguiente
          </button>
        </div>
      </mat-step>
      <!-- STEP 2 - SOBRE TI | DATOS DE UBER LTO-->
      <mat-step
        [stepControl]="completedSteps.controls['step2']"
        *ngIf="creditType === '9'"
      >
        <ng-template matStepLabel>SOBRE TI </ng-template>
        <!-- SOBRE TI DAE -->
        <app-step-sobre-ti
          *ngIf="creditType === '9' && completedSteps.controls['step1'].valid"
          [saveRequest]="requestValueAboutYou.asObservable()"
          (formValidEvent)="enableAboutYou = $event"
          (stepAboutYouSavedEvent)="markStepSaved(2, $event)"
        ></app-step-sobre-ti>
        <div class="button-position" *ngIf="creditType === '9'">
          <button
            class="boton-siguiente"
            mat-button
            matStepperPrevious
            (click)="clicked = false"
          >
            Regresar
          </button>
          <button
            class="boton-siguiente"
            [disabled]="!enableAboutYou"
            (click)="sendRequestAboutYou()"
            mat-button
          >
            Siguiente
          </button>
        </div>
      </mat-step>
      <mat-step [completed]="uberAprovePrefilter" *ngIf="creditType === '1'">
        <ng-template matStepLabel>DATOS UBER </ng-template>
        <!-- DATOS UBER LTO(flujo nuevo LTO) -->
        <app-step-datos-uber-lto
          *ngIf="creditType === '1'"
          [saveRequest]="requestValueDataUberLto.asObservable()"
          (formValidEvent)="enableDataUberLto = $event"
          (stepDataUberLtoSavedEvent)="markStepSaved(2, $event)"
        ></app-step-datos-uber-lto>
        <div class="button-position" *ngIf="creditType === '1'">
          <button
            class="boton-siguiente"
            mat-button
            matStepperPrevious
            (click)="clicked = false"
          >
            Regresar
          </button>
          <button
            class="boton-siguiente"
            (click)="sendRequestDataUberLto()"
            [disabled]="!enableDataUberLto"
            mat-button
          >
            Siguiente
          </button>
        </div>
      </mat-step>
      <!-- STEP 3 - DATOS UBER | DOCUMENTOS PRINCIPALES -->
      <mat-step [stepControl]="completedSteps.controls['step3']">
        <ng-template matStepLabel
          >{{ creditType === "9" ? "DATOS UBER" : "DOCUMENTOS PRINCIPALES" }}
        </ng-template>
        <!-- DATA UBER DAE -->
        <app-step-datos-uber
          *ngIf="creditType === '9' && completedSteps.controls['step2'].valid"
          [saveRequest]="requestValueDataUber.asObservable()"
          (formValidEvent)="enableDataUber = $event"
          (stepDataUberSavedEvent)="markStepSaved(3, $event)"
        ></app-step-datos-uber>
        <div class="button-position" *ngIf="creditType === '9'">
          <button class="boton-siguiente" mat-button matStepperPrevious>
            Regresar
          </button>
          <button
            class="boton-siguiente"
            [disabled]="!enableDataUber"
            (click)="sendRequestDataUber()"
            mat-button
          >
            Siguiente
          </button>
        </div>
        <!-- DOCUMENTOS PRINCIPALES (flujo nuevo LTO) -->
        <app-step-documentos-principales-lto
          *ngIf="creditType === '1' && completedSteps.controls['step2'].valid"
          [saveRequest]="requestValueMainDocumentsLto.asObservable()"
          (formValidEvent)="enableMainDocumentsLto = $event"
          (stepMainDocumentLtoSavedEvent)="markStepSaved(3, $event)"
          [dataMainDocumentsLto]="comboData"
        ></app-step-documentos-principales-lto>
        <div class="button-position">
          <button
            *ngIf="creditType === '1'"
            class="boton-siguiente"
            mat-button
            matStepperPrevious
          >
            Regresar
          </button>
          <button
            *ngIf="creditType === '1'"
            class="boton-siguiente"
            (click)="sendRequestMainDocumentsLto()"
            mat-button
          >
            Siguiente
          </button>
        </div>
      </mat-step>
      <!-- STEP 4 - DATOS SECUNDARIOS | CARGA DE DOCUMENTOS -->
      <mat-step [stepControl]="completedSteps.controls['step4']">
        <ng-template matStepLabel>
          {{
            creditType === "9" ? "CARGAR DOCUMENTOS" : "DOCUMENTOS SECUNDARIOS"
          }}
        </ng-template>
        <!-- CARGA DOCUMENTO DAE -->
        <app-step-cargar-documentos
          *ngIf="creditType === '9' && completedSteps.controls['step3'].valid"
          [saveRequest]="requestValueLoadDocuments.asObservable()"
          (formValidEvent)="enableLoadDocuments = $event"
          (stepLoadDocumentSavedEvent)="markStepSaved(4, $event)"
          [dataLoadDocuments]="comboData"
        ></app-step-cargar-documentos>
        <div class="button-position" *ngIf="creditType === '9'">
          <button class="boton-siguiente" mat-button matStepperPrevious>
            Regresar
          </button>
          <button
            class="boton-siguiente"
            mat-button
            [disabled]="!enableLoadDocuments"
            (click)="sendRequestLoadDocuments()"
          >
            Siguiente
          </button>
        </div>
        <!-- DOCUMENTOS SECUNDARIOS LTO (flujo nuevo LTO)-->
        <app-step-documentos-secundarios-lto
          *ngIf="creditType === '1' && completedSteps.controls['step3'].valid"
          [saveRequest]="requestValueSecondaryDocumentsLto.asObservable()"
          (formValidEvent)="enableSecondaryDocumentsLto = $event"
          (stepSecondaryDocumentsSavedEvent)="markStepSaved(4, $event)"
          [dataSecondaryDocuments]="comboData"
        ></app-step-documentos-secundarios-lto>
        <div class="button-position" *ngIf="creditType === '1'">
          <button
            class="boton-siguiente"
            (click)="completeDocument()"
            mat-button
            matStepperPrevious
          >
            Regresar
          </button>
          <button
            class="boton-siguiente"
            (click)="sendRequestSecondaryDocumentsLto()"
            mat-button
            [disabled]="!enableSecondaryDocumentsLto"
          >
            Siguiente
          </button>
        </div>
      </mat-step>
      <!-- STEP 5 -  MAS INFORMACION | DOCUMENTOS SECUNDARIOS -->
      <mat-step [stepControl]="completedSteps.controls['step5']">
        <ng-template matStepLabel>MAS INFORMACIÓN </ng-template>
        <!-- MAS INFORMACION DAE -->
        <app-step-mas-informacion
          *ngIf="creditType === '9' && completedSteps.controls['step4'].valid"
          [saveRequest]="requestValueMoreInformation.asObservable()"
          (formValidEvent)="enableMoreInformation = $event"
          (stepMoreInformationSavedEvent)="markStepSaved(5, $event)"
          [dataMoreInformation]="comboData"
        ></app-step-mas-informacion>
        <div class="button-position" *ngIf="creditType === '9'">
          <button
            class="boton-siguiente"
            (click)="completeDocument()"
            mat-button
            matStepperPrevious
          >
            Regresar
          </button>
          <button
            class="boton-siguiente"
            mat-button
            (click)="sendRequestMoreInformation()"
            [disabled]="!enableMoreInformation"
          >
            Finalizar
          </button>
        </div>
        <app-step-mas-informacion-lto
          *ngIf="creditType === '1' && completedSteps.controls['step4'].valid"
          [saveRequest]="requestValueMoreInformationLto.asObservable()"
          (formValidEvent)="enableMoreInformationLto = $event"
          (stepMoreInformationLtoSavedEvent)="markStepSaved(5, $event)"
          [dataMoreInformationLto]="comboData"
        ></app-step-mas-informacion-lto>
        <div class="button-position" *ngIf="creditType == '1'">
          <button class="boton-siguiente" mat-button matStepperPrevious>
            Regresar
          </button>
          <button
            class="boton-siguiente"
            mat-button
            [disabled]="!enableMoreInformationLto"
            (click)="sendRequestMoreInformationLto()"
          >
            Finalizar
          </button>
        </div>
      </mat-step>
    </mat-stepper>
  </div>
</div>

<body *ngIf="randomMode === 1 && !legacyCampaign">
  <div class="container">
    <header class="header">
      <img
        src="../../../assets/images/VEMO_CONDUCE_LOGO.svg"
        alt="Logo Vemo Impulso"
      />
    </header>

    <main>
      <section class="details">
        <ng-container>
          <div>
            <h2 class="text-title">
              Ingresa tus datos y únete a nuestro
              <div class="container-subtitle">
                <h2 class="text-subtitle">equipo de conductores</h2>
              </div>
            </h2>
          </div>
        </ng-container>
      </section>

      <section class="more">
        <app-spinner *ngIf="!comboData"></app-spinner>

        <app-welcome-step-new
          *ngIf="comboData"
          [waysFindOut]="comboData.waysFindOut"
        ></app-welcome-step-new>
      </section>
    </main>
  </div>
</body>
